// extracted by mini-css-extract-plugin
export default {"icon":"ZoomToRobot_icon__AtwNu"};